const isProduction =
    window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1';

const _viteApiUrl = (import.meta.env.VITE_API_URL as string | undefined)?.replace(/\/$/, '');

export const API_BASE_URL: string = isProduction
    ? (_viteApiUrl ?? window.location.origin)
    : 'http://localhost:3000';
